import { render, staticRenderFns } from "./default-opt-in-form.vue?vue&type=template&id=21f6a034&scoped=true&"
import script from "./default-opt-in-form.vue?vue&type=script&lang=js&"
export * from "./default-opt-in-form.vue?vue&type=script&lang=js&"
import style0 from "./default-opt-in-form.vue?vue&type=style&index=0&id=21f6a034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6a034",
  null
  
)

export default component.exports